export default function getVariation(_0x55514e){return _0x55514e['split']('-')[0x1];}